import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersService } from './users.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UsersRoutingModule } from './users-routing.module';
import { MatTabsModule } from '@angular/material/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { GtagModule } from 'angular-gtag';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    providers: [UsersService],
    declarations: [UserProfileComponent],
    imports: [
        CommonModule,
        UsersRoutingModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        GtagModule,
        MatCheckboxModule
    ]
})
export class UsersModule {}
